<div class="modal fade" id="serverBrowserModal" tabindex="-1" aria-labelledby="serverBrowserModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title fw-bold" id="serverBrowserModalLabel">
                    Server Browser - {{ gameTitle }}
                </h5>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"
                    aria-label="Close"></button>
            </div>
            <div class="modal-body p-0">
                <!-- Server List -->
                <div class="d-flex flex-column" style="max-height: 600px;">
                    <div class="table-responsive">
                        <table class="table table-dark table-hover mb-0 align-middle">
                            <thead>
                                <tr class="border-secondary text-uppercase text-white-50 small">
                                    <th class="ps-4 py-4" style="width: 50%;">Server</th>
                                    <th class="py-4 text-center" style="width: 25%;">Players</th>
                                    <th class="pe-4 py-4 text-end" style="width: 25%;">Ping</th>
                                </tr>
                            </thead>
                            <tbody>
                                @for(server of servers; track server.ip + ':' + server.port) {
                                <tr class="server-row border-secondary cursor-pointer"
                                    [class.active]="activeServer().ip === server.ip && activeServer().port === server.port"
                                    [class.ping-low]="server.ping < 50"
                                    [class.ping-med]="server.ping >= 50 && server.ping < 150"
                                    [class.ping-high]="server.ping >= 150" (click)="selectActive(server)">
                                    <td class="ps-4 py-3">
                                        <div class="d-flex align-items-center">
                                            <img [src]="server.mapImage" class="server-thumb me-3" alt="map" />
                                            <div class="text-truncate">
                                                <div class="fw-bold text-white text-truncate">{{ server.name }}</div>
                                                <small class="text-white-50 text-uppercase" style="font-size: 0.72rem;">
                                                    {{ server.map }} &bull; {{ server.mod }}
                                                </small>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="text-center fw-semibold text-warning py-3">
                                        {{ server.players }}
                                    </td>
                                    <td class="pe-4 text-end py-3">
                                        <div class="d-inline-flex align-items-center">
                                            <div class="d-inline-flex align-items-end gap-1 ping-bars me-2"
                                                [class.ping-low]="server.ping < 50"
                                                [class.ping-med]="server.ping >= 50 && server.ping < 150"
                                                [class.ping-high]="server.ping >= 150">
                                                <span class="bar bar-1"></span>
                                                <span class="bar bar-2"></span>
                                                <span class="bar bar-3"></span>
                                                <span class="bar bar-4"></span>
                                            </div>
                                            <span class="ping-value text-white-50 small">{{ server.ping }}</span>
                                        </div>
                                    </td>
                                </tr>
                                }
                            </tbody>
                            <tfoot>
                                <tr class="border-secondary text-uppercase text-white-50 small fw-bold">
                                    <td class="ps-4 py-4">
                                        Servers: {{ servers.length }}
                                    </td>
                                    <td class="py-4 text-center text-success">
                                        Querying: {{ queryProgress() }}
                                    </td>
                                    <td class="pe-4 py-4 text-end">
                                        Avg Ping: {{ averagePing() }}ms
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
            <div class="modal-footer p-0 border-0 gap-0">
                <button type="button" class="btn btn-dark w-50 m-0 rounded-0 rounded-bottom-start fw-bold"
                    style="height: 4rem;" data-bs-dismiss="modal">Close</button>
                <button type="button" class="btn btn-danger w-50 m-0 rounded-0 rounded-bottom-end fw-bold"
                    style="height: 4rem;" data-bs-dismiss="modal" (click)="onSelect(activeServer())">
                    Select Server
                </button>
            </div>
        </div>
    </div>
</div>